import {useTranslation} from 'react-i18next';
import * as css from './LectureTile.css';
import {TTimetableSalesLecture} from '../../../../../../../redux/realtime/realtime.type';
import TileLecturers from './TileLecturers';
import {COLORS} from '../../colors';

function LectureTile({lecture}: {lecture: TTimetableSalesLecture}) {
    const {t} = useTranslation('realtime');
    const {amount, taken, percent} = lecture.capacity;
    const active = lecture.active === 1;
    const unlimited = amount == null;
    const soldOut = amount != null && amount > 0 && taken >= amount;
    return (
        <css.tile $active={active}>
            <css.tileTop>
                <css.statusRow>
                    <css.statusPill
                        title={t(active ? 'lectureActive' : 'lectureInactive')}
                        data-cy="lectureTile-status"
                    >
                        <css.statusText $active={active}>{t(active ? 'lectureActive' : 'lectureInactive')}</css.statusText>
                        <css.statusDot $c={active ? COLORS.active : COLORS.off} />
                    </css.statusPill>
                    <TileLecturers lecturers={lecture.lecturers} active={active} />
                </css.statusRow>
                <css.tileTitle $active={active} title={lecture.title}>{lecture.title}</css.tileTitle>
            </css.tileTop>
            <css.tileBottom>
                <css.metaRow>
                    {unlimited
                        ? <css.unlimitedBadge>{t('unlimited')}</css.unlimitedBadge>
                        : soldOut && <css.soldOutBadge>{t('soldOut')}</css.soldOutBadge>}
                    <css.percentGroup>
                        <css.tilePercent>{unlimited ? taken : (percent == null ? '—' : `${percent}%`)}</css.tilePercent>
                        {unlimited
                            ? <css.tileCount>{t('registered')}</css.tileCount>
                            : <css.tileCount><css.countBold>{taken}</css.countBold>/{amount}</css.tileCount>}
                    </css.percentGroup>
                </css.metaRow>
                <css.progressTrack>
                    <css.progressFill $active={active} style={{width: `${Math.min(percent || 0, 100)}%`}} />
                </css.progressTrack>
            </css.tileBottom>
        </css.tile>
    );
}
export default LectureTile;
